import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Moon, Battery, Focus, HeartHandshake, Activity, CloudMoon, Heart, ShieldCheck, RefreshCw } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    icon: <Moon data-id="element-37" />,
    title: 'Duermes profundo',
    desc: 'Tu sistema nervioso deja de estar en alerta nocturna'
  }, {
    icon: <Battery data-id="element-38" />,
    title: 'Energía sostenida',
    desc: 'Sin los picos y caídas del estrés crónico'
  }, {
    icon: <Focus data-id="element-39" />,
    title: 'Claridad mental',
    desc: 'La niebla se disipa cuando el cortisol se regula'
  }, {
    icon: <HeartHandshake data-id="element-40" />,
    title: 'Relaciones más calmas',
    desc: 'Respondes desde la calma, no desde la reactividad'
  }, {
    icon: <Activity data-id="element-41" />,
    title: 'Cuerpo menos tenso',
    desc: 'La regulación somática libera tensión acumulada'
  }, {
    icon: <CloudMoon data-id="element-42" />,
    title: 'Noches en paz',
    desc: 'Rutina nocturna que apaga el modo alerta'
  }, {
    icon: <Heart data-id="element-43" />,
    title: 'Reconexión contigo',
    desc: 'Recuperas tu identidad más allá del estrés'
  }, {
    icon: <ShieldCheck data-id="element-44" />,
    title: 'Control emocional real',
    desc: 'No supresión, sino regulación genuina'
  }, {
    icon: <RefreshCw data-id="element-45" />,
    title: 'Hábitos que duran',
    desc: 'No fuerza de voluntad, sino reprogramación'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <h2 className="font-display font-bold text-3xl md:text-4xl text-teal mb-4" data-id="element-49">
            Lo que cambia cuando tu sistema interno se regula:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-50">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex flex-col items-start p-6 rounded-2xl bg-beige/30 border border-sage/10 hover:bg-beige/60 transition-colors" data-id="element-51">
              <div className="w-12 h-12 rounded-xl bg-gold/15 text-gold flex items-center justify-center mb-4" data-id="element-52">
                {cloneElement(b.icon as React.ReactElement, {
              size: 24
            })}
              </div>
              <h3 className="font-heading font-bold text-lg text-teal mb-2" data-id="element-53">
                {b.title}
              </h3>
              <p className="text-neutral-gray text-sm leading-relaxed font-sans" data-id="element-54">
                {b.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}